import { Navigate, useLocation } from "react-router-dom";
import * as React from "react";

import { useAuth } from "../../hooks/useAuth";

import Header from "../Header/Header";

export const RequireAuth = ({ children }) => {
  let location = useLocation();
  const { isLoggedIn } = useAuth();

  if (!isLoggedIn.current) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <>
      <Header />
      {children}
    </>
  );
};

export default RequireAuth;
